import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';

export default () => {
  const { room, isEnded } = useVideoContext();
  const [state, setState] = useState('disconnected'); // 'disconnected' | 'connected' | 'reconnecting'

  useEffect(() => {
    if (room) {
      const setRoomState = () => setState(room.state);
      setRoomState();
      room.on('disconnected', setRoomState).on('reconnected', setRoomState).on('reconnecting', setRoomState);
      return () => {
        room.off('disconnected', setRoomState).off('reconnected', setRoomState).off('reconnecting', setRoomState);
      };
    }
  }, [room]);

  return isEnded ? 'ended' : state;
};
